var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-topprogress',{ref:"topProgress",attrs:{"maximum":_vm.maxTopProgress,"trickleSpeed":_vm.trickleSpeed}})
}
var staticRenderFns = []

export { render, staticRenderFns }